import type { GraphpadWidgetConfig } from '@examdojo/math-widget/widgets/graphpad';
import { ContentBlockType, WidgetBlock } from '../../../model';

export const DEFAULT_WIDGET_CONFIG = {
  id: 'default-widget',
  type: 'graphpad',
  params: {
    f: { type: 'quadratic', params: { a: 1, b: 0, c: -4 } },
    'f-roots': { type: 'roots', params: { of: 'f' } },
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -10, xEnd: 10, yStart: -10, yEnd: 10 },
      grid: { type: 'lines', visible: false },
      axes: true,
    },
    elements: {
      f: { curve: { color: 'sky', strokeWidth: 2 } },
      'f-roots': { point: { color: 'sky', label: { contentVariant: 'name', position: 'bottom' } } },
    },
  },
} satisfies GraphpadWidgetConfig;

export const DEFAULT_WIDGET_PROPS: Omit<WidgetBlock, 'id'> = {
  type: ContentBlockType.Widget,
  widget_type: 'graphpad',
  config: DEFAULT_WIDGET_CONFIG,
};
